import { transitionComplete } from './timedEvents';

export const switchItemsAnimation = (
  $moduleToShow,
  $moduleGroup,
  hideAnimationClass = 'hidden'
) => {
  if (!$moduleToShow) return;

  $moduleGroup.forEach(($module) => $module.classList.add(hideAnimationClass));
  transitionComplete(() => {
    $moduleGroup.forEach(
      ($module) => ($module.hidden = $module !== $moduleToShow)
    );
    $moduleToShow.classList.remove(hideAnimationClass);
  });
};
